import { render } from "./CheckboxSingle.vue?vue&type=template&id=b9c7f35e&ts=true&lang=pug"
import script from "./CheckboxSingle.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxSingle.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__